"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLanguageCookieValue = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _constants = require("../constants");
/**
 * Gets new language cookie value
 */
const getLanguageCookieValue = () => _jsCookie.default.get(_constants.LANGUAGE_COOKIE_KEY);
exports.getLanguageCookieValue = getLanguageCookieValue;